const CLERK_ROLES = new Set([
  "CLERK",
  "CHIEF CLERK",
  "MASTER CLERK",
  "DORCUS CLERK",
  "DISPATCH CLERK",
  "REGISTRY CLERK",
  "TRAINING CLERK",
  "TYPING CLERK",
  "ARCHIVE CLERK",
  "TFC CLERK",
  "CLK CD",
  "COMCEN",
  "COM CEN",
  "TYPIST/SP STATE",
  "TYPIST",
  "CLERK GD",
  "TYPIST & SUPPORT STAFF",
  "SUPPORT STAFF",
]);

export const normalizeDashboardRole = (role) =>
  String(role || "").replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim().toUpperCase();

export const isClerkDashboardRole = (role) => {
  const normalized = normalizeDashboardRole(role);
  return (
    CLERK_ROLES.has(normalized) ||
    normalized.includes("CLERK") ||
    normalized.includes("TYPIST") ||
    normalized.includes("COMCEN") ||
    normalized.includes("COM CEN")
  );
};

export { CLERK_ROLES };
